import React from "react";

import { Form, FormCheckProps } from "react-bootstrap";

import { Controller, RegisterOptions, useFormContext } from "react-hook-form";

import styles from "./Checkbox.module.scss";

type CheckboxProps = {
  label: string;
  name: string;
  rules?: RegisterOptions;
} & Omit<FormCheckProps, "label" | "type">;

const Checkbox = ({ label, name, rules, ...rest }: CheckboxProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <Form.Group>
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field: { onChange, value, ...restFieldProps }, fieldState }) => {
            return (
              <Form.Check
                className={styles["form-check"]}
                type="checkbox"
                label={<div className="">{label}</div>}
                aria-invalid={fieldState.error !== undefined}
                checked={value || false}
                onChange={(e) => onChange(e.target.checked)}
                {...restFieldProps}
                {...rest}
              />
            );
          }}
        />
        {errors?.[name]?.message && (
          <Form.Control.Feedback type="invalid" className="d-block">
            {errors?.[name]?.message.toString()}
          </Form.Control.Feedback>
        )}
      </Form.Group>
    </>
  );
};

export default Checkbox;
